const normalizeResults = (data, year) => ({
  id: data?.id || year,
  participants: data?.participants || [],
  sports: data?.sports || [],
  notes: data?.notes || [],
});

export const fetchResults = async (setResults, year) => {
  const statusbarElement = document.querySelector(".statusbar");

  const setStatusColor = (color) => {
    if (statusbarElement) {
      statusbarElement.style.backgroundColor = color;
    }
  };

  const getApiKey = () => {
    let apikey = localStorage.getItem("apikey");
    while (!apikey) {
      const userApikey = prompt("Apikey:");
      if (userApikey) {
        localStorage.setItem("apikey", userApikey);
        apikey = userApikey;
      } else {
        alert("Apikey is required");
      }
    }
    return apikey;
  };

  const getResults = async () => {
    const apikey = getApiKey();

    const response = await fetch(
      `https://api.katkarapu-instituutti.link/v1/results/${year}`,
      {
        headers: { "x-api-key": apikey },
      }
    );

    if (response.status === 403) {
      localStorage.removeItem("apikey");
      return getResults(); // retry
    }

    if (!response.ok) {
      throw new Error(`Request failed: ${response.status}`);
    }
    const data = await response.json();
    setResults(normalizeResults(data, year));

    return;
  };

  try {
    setStatusColor("#ff6865"); // red
    await getResults();
    setStatusColor("#e6ffe3"); // green
  } catch (error) {
    console.error("Error updating remote results:", error);
    setStatusColor("#ff6865");
  }
};

export const updateRemoteResults = async (results) => {
  const statusbarElement = document.querySelector(".statusbar");

  const setStatusColor = (color) => {
    if (statusbarElement) {
      statusbarElement.style.backgroundColor = color;
    }
  };

  const getApiKey = () => {
    let apikey = localStorage.getItem("apikey");
    while (!apikey) {
      const userApikey = prompt("Apikey:");
      if (userApikey) {
        localStorage.setItem("apikey", userApikey);
        apikey = userApikey;
      } else {
        alert("Apikey is required");
      }
    }
    return apikey;
  };

  const sendUpdate = async () => {
    const apikey = getApiKey();

    const response = await fetch(
      `https://api.katkarapu-instituutti.link/v1/results`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": apikey,
        },
        body: JSON.stringify(results),
      }
    );

    if (response.status === 403) {
      localStorage.removeItem("apikey");
      alert("Invalid apikey, please enter again.");
      return sendUpdate(); // retry
    }

    if (!response.ok) {
      throw new Error(`Request failed: ${response.status}`);
    }

    return response;
  };

  try {
    setStatusColor("#ff6865"); // red
    await sendUpdate();
    setStatusColor("#e6ffe3"); // green
  } catch (error) {
    console.error("Error updating remote results:", error);
    setStatusColor("#ff6865");
  }
};

export const refreshLock = async (setLocked, setLockInfo) => {
  try {
    const LOCK_TIMEOUT = 10000;
    let userName = localStorage.getItem("username");
    if (!userName) {
      userName = crypto.randomUUID();
      localStorage.setItem("username", userName);
    }
    const res = await fetch(
      "https://api.katkarapu-instituutti.link/v1/results/lock"
    );
    const data = await res.json();
    setLockInfo(data);

    if (!data.lockedBy || data.lockTime < Date.now() - LOCK_TIMEOUT || data.lockedBy === userName) {
      // we can claim the lock
      await fetch("https://api.katkarapu-instituutti.link/v1/results/lock", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: "lock",
          lockedBy: userName,
          lockTime: Date.now(),
        }),
      });
      setLocked(false);
    } else {
      setLocked(true);
    }
  } catch (err) {
    console.error("Failed to refresh lock:", err);
  }
};
